// extracted by mini-css-extract-plugin
export default {"webPublishingSection":"lkA6LmIhdQwpIBZArvk3"};